module.exports = "pegasus_template/assets/themecapture1/launch/200.png";